<template>
  <div>
    <!-- TOPBAR -->
    <v-app-bar app light color="label">
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="white--text"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="text-uppercase white--text pl-0">
        <span class="font-weight-light text-none">{{
          $t("mainMenu.toolbarTitlePortal")
        }}</span>
        <span class="font-weight-light">{{
          $t("mainMenu.toolbarTitleFirst")
        }}</span>
        <span>{{ $t("mainMenu.toolbarTitleSecond") }}</span>
        <span
          no-gutters
          justify="end"
          class="caption font-weight-bold font-italic white--text text-none"
        >
          {{ $t("version") }}&#58;&nbsp;{{ version }}
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <base-select-language /> -->
      <v-badge
        top
        right
        color="red"
        overlap
        :value="existsUnreadNotifications"
        class="mx-3"
        v-if="!isConiuge"
      >
        <div slot="badge" class="font-weight-bold">
          {{ numberOfUnreadNotifications }}
        </div>
        <v-tooltip bottom content-class="portal-tooltip-inverted">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              icon
              text
              color="white"
              @click="openUnreadNotificationsPanel"
            >
              <v-icon>fas fa-bell</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("mainMenu.notificationButtonTitle") }}</span>
        </v-tooltip>
      </v-badge>
      <v-tooltip bottom content-class="portal-tooltip-inverted">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" @click="logout" text color="white">
            <span>{{ $t("signout") }}</span>
            <v-icon right>exit_to_app</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("mainMenu.logoutButtonTitle") }}</span>
      </v-tooltip>
    </v-app-bar>

    <!-- MENU' -->
    <v-navigation-drawer
      app
      floating
      width="315"
      light
      color="label"
      v-model="drawer"
    >
      <v-row no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="ma-4">
          <div>
            <img
              class="official-logo text-center"
              alt="Fondo EST"
              src="../../restricted-library/assets/images/official-logo.png"
            />
          </div>
        </v-col>
      </v-row>
      <!-- User full name -->
      <v-card color="primary" flat tile>
        <v-row no-gutters align="center" class="pa-2" v-if="isSmallDevice">
          <v-col cols="auto" class="mr-2">
            <v-avatar
              class="rounded-circle user-avatar"
              @click="openAccountDetails"
            >
              <span
                v-if="getUserInitials"
                class="title font-weight-medium white--text"
                >{{ getUserInitials }}</span
              >
              <v-icon v-else color="white">fas fa-user</v-icon>
            </v-avatar>
          </v-col>
          <v-col cols="auto" class="mr-2">
            <strong class="white--text">{{ userFullName }}</strong>
          </v-col>
          <v-col cols="auto">
            <v-icon @click="logout" color="white">exit_to_app</v-icon>
          </v-col>
        </v-row>
        <v-row no-gutters align="center" class="pa-2" v-else>
          <v-col cols="12" xs="2" sm="2" md="2" lg="2" xl="2" class="mr-2">
            <v-tooltip bottom content-class="portal-tooltip-inverted">
              <template v-slot:activator="{ on }">
                <v-avatar
                  v-on="on"
                  class="rounded-circle user-avatar"
                  @click="openAccountDetails"
                >
                  <span
                    v-if="getUserInitials"
                    class="title font-weight-medium white--text"
                    >{{ getUserInitials }}</span
                  >
                  <v-icon v-else color="white">fas fa-user</v-icon>
                </v-avatar>
              </template>
              <span>{{ $t("mainMenu.profileButtonTitle") }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" xs="8" sm="8" md="8" lg="8" xl="8">
            <strong class="white--text">{{ userFullName }}</strong>
          </v-col>
          <v-col cols="12" xs="1" sm="1" md="1" lg="1" xl="1">
            <v-tooltip bottom content-class="portal-tooltip-inverted">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" @click="logout" color="white"
                  >exit_to_app</v-icon
                >
              </template>
              <span>{{ $t("mainMenu.logoutButtonTitle") }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card>
      <!-- Pin -->
      <v-card color="primary" flat tile v-if="isPinActive">
        <v-row no-gutters align="center" class="px-2 pb-2">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <span
              class="subtitle-2 font-weight-bold font-italic white--text text-uppercase"
              >{{ $t("mainMenu.pinText") }}&#58;&nbsp;
              <span class="subtitle-1 font-weight-bold">{{
                userPin
              }}</span></span
            >
          </v-col>
        </v-row>
      </v-card>
      <!-- Menù -->
      <v-list v-for="(item, i) in menu" :key="i" class="py-0">
        <v-list-item
          v-if="item.visible"
          @click="callFirstLevelMenu(item.routeName)"
          active-class="menu-voice-highlighted"
          :class="
            item.routeName === $route.name ? 'menu-voice-highlighted' : ''
          "
        >
          <v-list-item-action>
            <img
              v-if="isAnInternalIcon(item.iconType)"
              :src="
                require('@/restricted-library/assets/icons/'.concat(item.icon))
              "
              alt=""
              width="30%"
            />
            <v-icon v-else dark>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              class="white--text subtitle-1 font-weight-bold"
              :title="$t(item.showName)"
            >
              {{ $t(item.showName) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
// import BaseSelectLanguage from "../BaseSelectLanguage";

export default {
  components: {
    // BaseSelectLanguage
  },
  data() {
    return {
      drawer: true,
      iconSA: require("@/restricted-library/assets/images/w_sa_logo.png"),
      versamentoVolontarioUrl: process.env.VUE_APP_VERSAMENTO_VOLONTARIO_URL,
      gestioneFamiliariUrl: process.env.VUE_APP_GESTIONE_FAMILIARI_URL,
      isPinActive: process.env.VUE_APP_IS_PIN_ACTIVE != "false",
      version: process.env.VUE_APP_VERSION
    };
  },
  computed: {
    isSmallDevice() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    menu() {
      return this.$store.getters["login/getMenu"];
    },
    isConiuge() {
      return this.$store.getters["profile/getIsConiuge"];
    },
    userFullName() {
      return this.$store.getters["login/userFullName"];
    },
    userPin() {
      return this.$store.getters["login/userPin"];
    },
    getUserInitials() {
      return this.$store.getters["login/userInitials"];
    },
    numberOfUnreadNotifications() {
      return this.$store.getters[
        "notifications/getNumberOfUnreadNotifications"
      ];
    },
    existsUnreadNotifications() {
      return (
        this.numberOfUnreadNotifications && this.numberOfUnreadNotifications > 0
      );
    }
  },
  methods: {
    logout() {
      let routeName = this.$route.name;
      if (routeName === "bookingWizard") {
        let dialogTitle = this.$t("dialog.alerts.leaveWizard.title");
        this.$store.commit(
          "baseDialog/openDialog",
          {
            title: dialogTitle,
            buttons: [
              {
                text: this.$t("dialog.alerts.leaveWizard.cancel"),
                outlined: true,
                action: () => {
                  this.$store.commit("baseDialog/reset", null, {
                    root: true
                  });
                }
              },
              {
                text: this.$t("dialog.alerts.leaveWizard.forward"),
                action: () => {
                  this.$store.commit("baseDialog/reset", null, {
                    root: true
                  });
                  this.$store.dispatch("doLogout", null, { root: true });
                }
              }
            ]
          },
          { root: true }
        );
      } else {
        this.$store.dispatch("doLogout", null, { root: true });
      }
    },
    openAccountDetails() {
      this.$router.push("profile");
    },
    async openUnreadNotificationsPanel() {
      await this.$store.dispatch("notifications/getUnreadNotifications");
      if (this.existsUnreadNotifications) {
        this.$store.commit("notifications/setShowNotificationPanel", true);
      } else {
        this.$router.push({ name: "centroNotifiche" });
      }
    },
    callFirstLevelMenu(routeName) {
      if (routeName === "versamentoVolontario") {
        window.open(this.versamentoVolontarioUrl, "_blank");
      } else {
        this.$router.push({ name: routeName });
      }
    },
    isAnInternalIcon(iconType) {
      return iconType && iconType === "internal";
    }
  }
};
</script>

<style scoped>
.user-avatar {
  border: 2px solid white;
}
.user-avatar:hover {
  background: var(--label);
  cursor: pointer;
}
.v-navigation-drawer {
  background: url(../../restricted-library/assets/images/squares.png) no-repeat
      left bottom,
    var(--label) !important;
}
.v-navigation-drawer .v-list {
  background: transparent;
}
.v-navigation-drawer .menu-voice-highlighted {
  background-color: var(--primary) !important;
}
.v-navigation-drawer >>> .v-list-item {
  padding: 0;
  overflow: hidden;
  flex-wrap: nowrap;
}
.v-navigation-drawer >>> .v-list-item .v-list-item__action {
  width: 80px !important;
  max-width: 80px !important;
  min-width: 80px !important;
  padding: 0 !important;
  margin: 0;
  align-items: center;
  justify-content: center;
  box-sizing: border-box !important;
}
.v-navigation-drawer >>> .v-list .v-list-item__content {
  width: 160px !important;
  min-width: 160px;
}
</style>
